var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.59986V5.60948M8 10.8164V10.8426M11.78 13.3332H4.22005C3.1874 13.3332 2.31595 12.6507 2.04177 11.717C1.92473 11.3184 2.06854 10.9032 2.28851 10.5498L6.06846 3.73385C6.95407 2.31072 9.04594 2.31072 9.93154 3.73386L13.7115 10.5498C13.9315 10.9032 14.0753 11.3184 13.9582 11.717C13.6841 12.6507 12.8126 13.3332 11.78 13.3332Z",
    stroke: "#FF543E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleError);
export default __webpack_public_path__ + "static/media/alert-triangle-error.6f7780bdcda144562ef3d700a64d082f.svg";
export { ForwardRef as ReactComponent };